
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { GamePlan } from '@/types/gamePlanner';

interface GamePlanDisplayProps {
  gamePlan: GamePlan;
}

export const GamePlanDisplay: React.FC<GamePlanDisplayProps> = ({ gamePlan }) => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>{gamePlan.name}</CardTitle>
        </CardHeader>
        <CardContent>
          {gamePlan.description && (
            <p className="text-muted-foreground mb-4">{gamePlan.description}</p>
          )}
          <div className="bg-muted p-4 rounded-md">
            <p className="text-sm text-muted-foreground">Game plan flow data</p>
            <pre className="text-xs mt-2 overflow-auto">
              {JSON.stringify(gamePlan.flow_data, null, 2)}
            </pre>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
